<template>
<div class="input">
  <input-mask
      v-if="name === 'number'"
      type="text"
      :name="name"
      :placeholder="placeholder"
      mask="+7 999 999 99 99"
      @input="$emit('setNumber',$event)"
  />
  <input v-if="name === 'name'" type="text" :name="name"
         :placeholder="placeholder" @input="$emit('setName',$event.target.value)">
  <input v-if="name === 'email'" type="email" :name="name" :placeholder="placeholder" @input="$emit('setEmail',$event.target.value)">
</div>
</template>

<script>
export default {
  name: "Input",
  props: ["name","placeholder"],
}
</script>
<style lang="scss">
@import "input";
</style>